import React from 'react';
import './MobileNavigation.css';
import { TableIcon, ChartNoAxesCombined, MapPin, Star, Bell } from 'lucide-react';

const MobileNavigation = ({ selectedView, setSelectedView, onOpenSavedSearches, onOpenAlerts, unreadCount = 0 }) => {
  return (
    <nav className="mobile-nav">
      <div  
        className={`mobile-nav-item data ${selectedView === 'table' ? 'active' : ''}`} 
        onClick={() => setSelectedView('table')}
      >
        <TableIcon size={20} />
        <span>Data</span>
      </div>
      <div  
        className={`mobile-nav-item charts ${selectedView === 'chart' ? 'active' : ''}`} 
        onClick={() => setSelectedView('chart')}
      >
        <ChartNoAxesCombined size={20} />
        <span>Charts</span>
      </div>
      <div  
        className={`mobile-nav-item map ${selectedView === 'map' ? 'active' : ''}`} 
        onClick={() => setSelectedView('map')}
      >
        <MapPin size={20} />
        <span>Map</span>
      </div>
      <div  
        className="mobile-nav-item saved"
        onClick={onOpenSavedSearches}
      >
        <Star size={20} />
        <span>Saved</span>
      </div>
      <div  
        className="mobile-nav-item alerts"
        onClick={onOpenAlerts}
      >
        <div className="mobile-nav-icon-wrap">
          <Bell size={20} />
          {unreadCount > 0 && (
            <span className="mobile-nav-badge">{unreadCount}</span>
          )}
        </div>
        <span>Alerts</span>
      </div>
    </nav>
  );
};

export default MobileNavigation;